(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.directive('searchBox', ['$state', '$sce', '$translate', 'HelperService', 'SharedAgendaService', SearchBoxFn]);

    /* directive for search box */
    function SearchBoxFn($state, $sce, $translate, HelperService, SharedAgendaService) {

        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/search/templates/search-box.template.html'
        };
        return directive;

        function link(scope, element) {
            activate();
            scope.vm.sharedagendaServiceData = SharedAgendaService.data;
            scope.vm.sharedagendaServiceData.searchStr = '';
            scope.errorMessage = '';

            scope.htmlSearchTips =  $sce.trustAsHtml($translate.instant('global_search_tips_html'));

            scope.searching = false;
            
            // activate
            function activate() {
                scope.errorMessage = '';
            }

            // do searching
            scope.search = function () {
                if (!scope.searching) {
                    scope.searching = true;

                    //clear errorMessage
                    scope.errorMessage = '';

                    if (!HelperService.enoughCharactersForFilterCheck(scope.vm.sharedagendaServiceData.searchStr)){
                        scope.errorMessage = $translate.instant('Search_Input_Validation_Error');
                    }
                    $state.go('Home.Search', { searchStr: scope.vm.sharedagendaServiceData.searchStr, errorMessage:  scope.errorMessage}, { reload: $state.current.name });
                    
                    setTimeout(() => { scope.$apply(() =>  scope.searching = false); }, 1000);
                }
                
            };
        }
    }
})();